module.exports = __webpack_public_path__ + "img/portrait.210edb63.jpg";